<div class="adjustment__page my-5"><!-- report__page__with__extra__scroll -->
  <div class="row mb-3 justify-content-md-center">
    <div class="col-lg-10 col-md-12">
      <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
        Use this section to identify additional adjustments to the Company’s Income Statement.
      </div>

      <div class="helper-text">
        <div class="mb-10">Adjustments are made to a company’s income statement in order to show the true cash flows to the business. The reasoning on why these adjustments are made is because oftentimes the owner’s of small to medium sized businesses (SMB’s) will co-mingle non-business operating and/or non-recurring income or expenses on the Company’s income statements. </div>
        <div [class.ellipsis]="isEllipsis">
          In order to arrive at the true economic cash flow of a company, financial statement adjustments, otherwise known as addbacks, must be either added or removed from a company's net income. The most common examples of non-recurring and non-business operating income/expenses are Owner’s discretionary expenses like health insurance, benefits/pension plan, personal auto/truck expenses, and Net gain or loss from the sale of an asset.
          <div class="mt-10" *ngIf="!isEllipsis">
            In order to make any necessary adjustments to the Income Statement, click the 'Add Normalizing Adjustments' button below:
          </div>
        </div>
        <div role="button" class="mt-2 font-weight-bold color--blue" *ngIf="isEllipsis" (click)="isEllipsis = false">Read More</div>
        <div role="button" class="mt-2 font-weight-bold color--blue" *ngIf="!isEllipsis" (click)="isEllipsis = true">Read Less</div>
      </div>
    </div>
  </div>

  <!-- Top Table -->
  <div class="row mt-5 top__table">
    <div class="col-lg-4 col-md-6 col-6 table-side-container">
      <div class="header top"></div>

      <!-- #region "Normalized Income Statement" -->
      <div class="header blank__header cursor-initial" role="button"> <!-- (click)="expandNormalizedIncomeStatement = !expandNormalizedIncomeStatement" -->
        <div>Adjusted Income Statement</div>
        <!--<div class="icon">
          <em class="fa fa-caret-up color&#45;&#45;blue" *ngIf="expandNormalizedIncomeStatement"></em>
          <em class="fa fa-caret-down color&#45;&#45;blue" *ngIf="!expandNormalizedIncomeStatement"></em>
        </div>-->
      </div>
      <ng-container *ngIf="expandNormalizedIncomeStatement">
        <div class="sub__header">Revenue</div>
        <div class="sub__header">Profit before Taxes</div>
      </ng-container>
      <!-- #endregion -->

      <!-- #region "Interest and Non-Cash Adjustments" -->
      <div class="header blank__header" role="button"
        (click)="expandInterestandNonCashAdjustments = !expandInterestandNonCashAdjustments">
        <div>Interest and Non-Cash Adjustments</div>
        <div class="icon">
          <em class="fa fa-caret-up color--blue" *ngIf="expandInterestandNonCashAdjustments"></em>
          <em class="fa fa-caret-down color--blue" *ngIf="!expandInterestandNonCashAdjustments"></em>
        </div>
      </div>
      <ng-container *ngIf="expandInterestandNonCashAdjustments">
        <div class="sub__header">Add: Interest</div>
        <div class="sub__header">Add: Depreciation</div>
        <div class="sub__header">Add: Amortization</div>
      </ng-container>
      <!-- #endregion -->

      <!-- #region "Owner(s)’s Salary Adjustments" -->
      <div class="header blank__header" role="button"
        (click)="expandOwnerSalaryAdjustments = !expandOwnerSalaryAdjustments">
        <div>Owner(s)’s Salary Adjustments</div>
        <div class="icon">
          <em class="fa fa-caret-up color--blue" *ngIf="expandOwnerSalaryAdjustments"></em>
          <em class="fa fa-caret-down color--blue" *ngIf="!expandOwnerSalaryAdjustments"></em>
        </div>
      </div>
      <ng-container *ngIf="expandOwnerSalaryAdjustments">
        <div class="sub__header" *ngIf="isForm1065">
          Add: Guaranteed Payments to Partners
        </div>
        <div class="sub__header">
          Add: Owner(s)’s Salary
        </div>
        <div class="sub__header">
          Add: Payroll Taxes Adjustments
        </div>
        <ng-container *ngIf="reportService.hasOwnershipAdjustments()">
          <ng-container *ngFor="let onr of lowRsOwner; let i = index;">
            <div class="sub__header sub__header__ellipsis">
              Less: Annual Fair Market Replacement Salary ({{onr.DISPLAY_NAME || onr.NAME}})
            </div>
            <div class="sub__header sub__header__ellipsis">
              Less: Payroll Taxes Adjustments ({{onr.DISPLAY_NAME || onr.NAME}})
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="reportService.hasOwnershipUnnamedGmAdjustments()">
          <div class="sub__header">
            Add: General Manager Salary
          </div>
          <div class="sub__header" *ngIf="checkGeneralManagerTaxes()">
            Add: Payroll Taxes Adjustments
          </div>
        </ng-container>
      </ng-container>
      <!-- #endregion -->

      <!-- #region "Fair Market Rent Adjustments" -->
      <div class="header blank__header" role="button" *ngIf="reportService.showRentAdjustments()"
        (click)="expandFairMarketRentAdjustments = !expandFairMarketRentAdjustments">
        <div>Fair Market Rent Adjustments</div>
        <div class="icon">
          <em class="fa fa-caret-up color--blue" *ngIf="expandFairMarketRentAdjustments"></em>
          <em class="fa fa-caret-down color--blue" *ngIf="!expandFairMarketRentAdjustments"></em>
        </div>
      </div>
      <ng-container *ngIf="expandFairMarketRentAdjustments">
        <ng-container *ngFor="let rnt of currentReport?.LATEST?.LOCATION_LIST; let j = index;">
          <ng-container *ngIf="rnt.IS_OWNED || (!rnt.IS_OWNED && rnt.IS_RENT_INCREASE)">
            <div class="sub__header sub__header__ellipsis" *ngIf="(rnt.IS_OWNED && !rnt.IS_OWNED_ON_BS) || (!rnt.IS_OWNED && rnt.IS_RENT_INCREASE)">
              Add: Current Rent Expense for {{rnt.DISPLAY_NAME || rnt.NAME}}
            </div>
            <div class="sub__header sub__header__ellipsis">
              Less: Annual Fair Market Rent Expense for {{rnt.DISPLAY_NAME || rnt.NAME}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- #endregion -->

    </div>

    <div class="col-lg-8 col-md-6 col-6">
      <div class="row flex-nowrap table__body custom__scroll vertical__Scroll overflow-y-hidden">
        <div class="col-lg-3 col-md-9 col-9 p-0 table-column" *ngFor="let ist of IncomeStatementTable; let i = index">

          <div class="table-column-header">
            <div>{{ist.YEAR}}</div>
            <div class="color-secondary-gray font-size-12">{{reportService.changeTextStyle(ist.FINANCIAL_TYPE)}}</div>
          </div>

          <!-- #region "Normalized Income Statement" -->
          <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
            <!--{{reportService.getTotal([ist.REVENUE, ist.PROFIT]) | number}}-->
          </div>
          <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            <!--0-->
          </div>
          <ng-container *ngIf="expandNormalizedIncomeStatement">
            <div class="table-column-cell">

              <number-input [(ngModel)]="ist.REVENUE"
                [classes]="'input silent-input'"
                #REVENUE="ngModel"
                name="REVENUE_{{i}}"
                (blur)="updateIncomeTableValue('REVENUE', ist)"
                [disabled]="!isEditMode || currentReport?.isLocked"
                [allowZero]="true"
                [clearZero]="false"
                *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                id="REVENUE_{{i}}"></number-input>

              <input type="text" id="adjustment-income-statement-na" class="input silent-input" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell last-border">

              <number-input [(ngModel)]="ist.PROFIT"
                [classes]="'input silent-input'"
                #PROFIT="ngModel"
                name="PROFIT_{{i}}"
                (blur)="updateIncomeTableValue('PROFIT', ist)"
                [disabled]="!isEditMode || currentReport?.isLocked"
                [allowZero]="true"
                [clearZero]="false"
                *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                id="PROFIT_{{i}}"></number-input>

              <input type="text" id="adjustment-income-statement-financial-type" class="input silent-input" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
          </ng-container>
          <!-- #endregion -->

          <!-- #region "Interest and Non-Cash Adjustments" -->
          <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
            {{reportService.getTotal([ist.INTEREST, ist.DEPRECIATION, ist.AMORTIZATION]) | number}}
          </div>
          <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            0
          </div>
          <ng-container *ngIf="expandInterestandNonCashAdjustments">
            <div class="table-column-cell">

              <number-input [(ngModel)]="ist.INTEREST"
                [classes]="'input silent-input'"
                #INTEREST="ngModel"
                name="INTEREST_{{i}}"
                (blur)="updateIncomeTableValue('INTEREST', ist)"
                [disabled]="!isEditMode || currentReport?.isLocked"
                [allowZero]="true"
                [clearZero]="false"
                *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                id="INTEREST_{{i}}"></number-input>

              <input id="adjustment-interest-and-non-cash" type="text" class="input silent-input" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell">

                <number-input [(ngModel)]="ist.DEPRECIATION"
                  [classes]="'input silent-input'"
                  #DEPRECIATION="ngModel"
                  name="DEPRECIATION_{{i}}"
                  (blur)="updateIncomeTableValue('DEPRECIATION', ist)"
                  [disabled]="!isEditMode || currentReport?.isLocked"
                  [allowZero]="true"
                  [clearZero]="false"
                  *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                  id="DEPRECIATION_{{i}}"></number-input>

              <input type="text" id="adjustment-interest-and-non-cash-dep" class="input silent-input" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell last-border">

              <number-input [(ngModel)]="ist.AMORTIZATION"
                [classes]="'input silent-input'"
                #AMORTIZATION="ngModel"
                name="AMORTIZATION_{{i}}"
                (blur)="updateIncomeTableValue('AMORTIZATION', ist)"
                [disabled]="!isEditMode || currentReport?.isLocked"
                [allowZero]="true"
                [clearZero]="false"
                *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                id="AMORTIZATION_{{i}}"></number-input>

              <input type="text" id="adjustment-update-income-table" class="input silent-input" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
          </ng-container>
          <!-- #endregion -->

          <!-- #region "Owner(s)’s Salary Adjustments" -->
          <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
            {{getSalaryAdjustmentsTotal(ist) | number}}
          </div>
          <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            0
          </div>
          <ng-container *ngIf="expandOwnerSalaryAdjustments">
            <div class="table-column-cell" *ngIf="isForm1065">

              <number-input [(ngModel)]="ist.GUARANTEED_PAYMENTS"
                [classes]="'input silent-input'"
                #GUARANTEED_PAYMENTS="ngModel"
                name="GUARANTEED_PAYMENTS_{{i}}"
                [disabled]="!isEditMode || currentReport?.isLocked"
                [allowZero]="true"
                [clearZero]="false"
                *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                (blur)="updateIncomeTableValue('GUARANTEED_PAYMENTS', ist)"
                id="GUARANTEED_PAYMENTS_{{i}}"></number-input>

              <input type="text" class="input silent-input" id="adjustment-guaranteed-payments" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell">

              <number-input [(ngModel)]="ist.OFFICER_COMP"
                [classes]="'input silent-input'"
                #OFFICER_COMP="ngModel"
                name="OFFICER_COMP_{{i}}"
                [disabled]="!isEditMode || currentReport?.isLocked"
                [allowZero]="true"
                [clearZero]="false"
                *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                (blur)="updateIncomeTableValue('OFFICER_COMP', ist)"
                id="OFFICER_COMP_{{i}}"></number-input>

              <input type="text" class="input silent-input" id="adjustment-officer-comp" disabled [value]="'0'"
                *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell">
              <div class="value" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                {{currencyPipe.transform(reportService.calculateTaxAdjustment(ist.OFFICER_COMP))}}
              </div>
              <div class="value" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                0
              </div>
            </div>
            <ng-container *ngIf="reportService.hasOwnershipAdjustments()">
              <ng-container *ngFor="let onr of lowRsOwner; let j = index;">
                <div class="table-column-cell">
                  <ng-container *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                    <number-input [(ngModel)]="onr.REPLACEMENT_SALARY"
                      [classes]="'input silent-input'"
                      #OWNER_SALARY="ngModel"
                      name="OWNER_SALARY_{{j}}_{{i}}"
                      [disabled]="!isEditMode || currentReport?.isLocked"
                      [allowZero]="true"
                      [clearZero]="false"
                      (blur)="updateOwnerSalaryValue('REPLACEMENT_SALARY', onr)"
                      *ngIf="isEditMode"
                      id="OWNER_SALARY_{{j}}_{{i}}"></number-input>

                      <div class="value" *ngIf="!isEditMode">
                        ({{currencyPipe.transform(onr.REPLACEMENT_SALARY)}})
                      </div>
                  </ng-container>

                  <input type="text" class="input silent-input" id="adjustment-replacement-salary" disabled [value]="'0'"
                    *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                </div>
                <div class="table-column-cell last-border">
                  <div class="value" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                    ({{currencyPipe.transform(reportService.calculateTaxAdjustment(onr.REPLACEMENT_SALARY))}})
                  </div>
                  <div class="value" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                    (0)
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="reportService.hasOwnershipUnnamedGmAdjustments()">
              <div class="table-column-cell">

                <number-input [(ngModel)]="ist.GM_SALARY"
                  [classes]="'input silent-input'"
                  #GM_SALARY="ngModel"
                  name="GM_SALARY_TOP_{{i}}"
                  [disabled]="!isEditMode || currentReport?.isLocked"
                  [allowZero]="true"
                  [clearZero]="false"
                  (blur)="updateIncomeTableValue('GM_SALARY', ist)"
                  *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                  id="GM_SALARY_TOP_{{i}}"></number-input>

                <input type="text" class="input silent-input" id="adjustment-gm-salary" disabled [value]="'0'"
                  *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
              </div>
              <div class="table-column-cell last-border" *ngIf="checkGeneralManagerTaxes()">
                <div class="value" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE' && !ist.GM_SALARY_TAX">
                  {{currencyPipe.transform(reportService.calculateTaxAdjustment(ist.GM_SALARY))}}
                </div>
                <div class="value" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE' || ist.GM_SALARY_TAX">
                  0
                </div>
              </div>
            </ng-container>
          </ng-container>
          <!-- #endregion -->

          <!-- #region "Fair Market Rent Adjustments" -->
          <ng-container *ngIf="reportService.showRentAdjustments()">
            <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
              {{getRentAdjustmentsTotal(ist) | number}}
            </div>
            <div class="table-column-cell input silent-input" *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
              0
            </div>
          </ng-container>
          <ng-container *ngIf="expandFairMarketRentAdjustments">
            <ng-container *ngFor="let rnt of currentReport?.LATEST?.LOCATION_LIST; let j = index;">
              <ng-container *ngIf="rnt.IS_OWNED || (!rnt.IS_OWNED && rnt.IS_RENT_INCREASE)">

                <div class="table-column-cell" *ngIf="(rnt.IS_OWNED && !rnt.IS_OWNED_ON_BS) || (!rnt.IS_OWNED && rnt.IS_RENT_INCREASE)">
                  <ng-container *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                    <ng-container *ngIf="rnt.RENT_EXPENSE_EACH_YEAR">

                      <number-input [ngModel]="getCurrentRentExpense(rnt.RENT_ADJUSTMENT_YEARLY, ist.ID)"
                        [classes]="'input silent-input'"
                        #CURRENT_RENT="ngModel"
                        name="CURRENT_RENT_{{j}}_{{i}}"
                        [disabled]="!isEditMode || currentReport?.isLocked"
                        [allowZero]="true"
                        [clearZero]="false"
                        (ngModelChange)="currentRentChange(rnt.RENT_ADJUSTMENT_YEARLY, ist.ID, $event)"
                        (blur)="updateLocationCurrentRentValue(rnt.RENT_ADJUSTMENT_YEARLY, ist.ID)"
                        *ngIf="isEditMode"
                        [allowNegative]="true"
                        id="CURRENT_RENT_{{j}}_{{i}}"></number-input>

                      <div class="value" *ngIf="!isEditMode">
                        {{currencyPipe.transformWithNegative(getCurrentRentExpense(rnt.RENT_ADJUSTMENT_YEARLY, ist.ID))}}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!rnt.RENT_EXPENSE_EACH_YEAR">

                      <number-input [(ngModel)]="rnt.RENT_EXPENSE"
                        [classes]="'input silent-input'"
                        #CURRENT_RENT="ngModel"
                        name="CURRENT_RENT_{{j}}_{{i}}"
                        [disabled]="!isEditMode || currentReport?.isLocked"
                        [allowZero]="true"
                        [clearZero]="false"
                        (blur)="updateLocationRentValue('RENT_EXPENSE', rnt)"
                        *ngIf="isEditMode"
                        [allowNegative]="true"
                        id="CURRENT_RENT_{{j}}_{{i}}"></number-input>

                      <div class="value" *ngIf="!isEditMode">
                        {{currencyPipe.transformWithNegative(rnt.RENT_EXPENSE)}}
                      </div>
                    </ng-container>
                  </ng-container>
                  <input type="text" class="input silent-input" id="adjustment-current-rent" disabled [value]="'0'"
                    *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                </div>

                <div class="table-column-cell last-border">
                  <ng-container *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                    <number-input [(ngModel)]="rnt.MARKET_RENT"
                      [classes]="'input silent-input'"
                      #MARKET_RENT="ngModel"
                      name="MARKET_RENT_{{j}}_{{i}}"
                      [disabled]="!isEditMode || currentReport?.isLocked"
                      [allowZero]="true"
                      [clearZero]="false"
                      (blur)="updateLocationRentValue('MARKET_RENT', rnt)"
                      *ngIf="isEditMode"
                      id="MARKET_RENT_{{j}}_{{i}}"></number-input>

                    <div class="value" *ngIf="!isEditMode">
                      ({{currencyPipe.transform(rnt.MARKET_RENT)}})
                    </div>
                  </ng-container>
                  <input type="text" id="adjustment-market-rent" class="input silent-input" disabled [value]="'0'"
                    *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                </div>

              </ng-container>
            </ng-container>
          </ng-container>
          <!-- #endregion -->

        </div>
      </div>
    </div>
  </div>

  <!-- Middle Table -->
  <div class="my-3">
    <form #adjustmentForm="ngForm" novalidate="novalidate" autocomplete="off">
      <div class="row vertical--table" *ngFor="let data of currentReport?.LATEST?.ADJUSTMENT_LIST; let i = index">
        <div class="col-lg-4 col-md-6 col-6 p-0 w-auto handle-description">
          <div class="d-flex">
            <div class="gray-border-right">
              <button type="button" id="{{'adjustments-delete-midd-row-'+i}}" class="ghost__button button small__button color--red font-size-18"
                (click)="!deleteInProgrss ? deleteMiddleRow(data.ID, i) : null" [disabled]="currentReport?.isLocked">
                <em class="fa fa-trash"></em>
              </button>
            </div>
            <div class="gray-border-right flex-grow-1">
              <div [ngClass]="{'input__error': !data.ADJUSTMENT_TYPE}" class="focus__border">
                <app-custom-select #ADJUSTMENT_TYPE="ngModel" [disabled]="currentReport?.isLocked"
                    [(ngModel)]="data.ADJUSTMENT_TYPE" [values]="adjustmentType"
                    placeholder="Type" name="ADJUSTMENT_TYPE_{{i}}" id="ADJUSTMENT_TYPE_{{i}}"
                    [isToolTip]="true" [classes]="'w-100'"
                    (valueSelected)="updateAdjustmentCell('ADJUSTMENT_TYPE', data, i)" required>
                </app-custom-select>
              </div>
            </div>
          </div>
          <div class="description-input" [ngClass]="{'input__error': (NAME.errors && (NAME.dirty || NAME.touched))}">
            <input type="text" appAlpaNumericWithSpace id="adjustment-update-cell" class="input silent-input" [disabled]="!data.ADJUSTMENT_TYPE" #NAME="ngModel"
              name="NAME_{{i}}" placeholder="Description" [(ngModel)]="data.NAME" maxlength="30"
              (blur)="updateAdjustmentCell('NAME', data)" required>
          </div>
        </div>
        <div class="col-lg-8 col-md-6 col-6 handle-alignment">
          <div class="row flex-nowrap custom__scroll vertical__Scroll overflow-y-hidden">
            <div class="col-lg-3 col-md-9 col-9 p-0 vertical-column" *ngFor="let ay of data.ADJUSTMENT_YEAR_LIST; let j = index">
              <div *ngIf="ay.INCOME_STATEMENT.FINANCIAL_TYPE != 'NOT_AVAILABLE'"
                [ngClass]="{'input__error': (ADJUSTMENT_YEAR_VALUE.errors && (ADJUSTMENT_YEAR_VALUE.dirty || ADJUSTMENT_YEAR_VALUE.touched))}">

                <number-input [(ngModel)]="ay.VALUE"
                  [classes]="'input silent-input'"
                  #ADJUSTMENT_YEAR_VALUE="ngModel"
                  name="ADJUSTMENT_YEAR_VALUE_{{i}}_{{j}}"
                  [disabled]="!data.ADJUSTMENT_TYPE || currentReport?.isLocked"
                  [allowZero]="true"
                  [clearZero]="true"
                  [required]="true"
                  [allowNegative]="data.ADJUSTMENT_TYPE == adjustmentTypeEnum.OTHER"
                  (blur)="updateAdjustmentYearCell('VALUE', ay)"
                  id="ADJUSTMENT_YEAR_VALUE_{{i}}_{{j}}"></number-input>

              </div>
              <div *ngIf="ay.INCOME_STATEMENT.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                <input type="text" id="adjustment-gm-salary-middle" class="input silent-input" disabled [value]="'0'">
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Add Button -->
  <div class="row mt-2">
    <button id="adjustments-add-middle-row-btn" type="button" class="button secondary__button large__button"
            (click)="addMiddleRow()" [disabled]="currentReport?.isLocked">
      Add Normalizing Adjustments (Add-back) +
    </button>
  </div>

  <!-- Bottom Table -->
  <div class="row mt-3 blue-border-top-2">
    <div class="col-lg-4 col-md-6 col-6 table-side-container gray-border-right">
      <div class="header">Total Adjustments</div>
      <div class="header">Seller's Discretionary Earnings (SDE)</div>
      <ng-container *ngIf="reportService.hasOwnershipAdjustments()">
        <div class="sub__header sub__header__ellipsis">Less: Annual Fair Market Replacement Salary ({{hiRsOwner?.DISPLAY_NAME || hiRsOwner?.NAME}})</div>
        <div class="sub__header sub__header__ellipsis">Less: Payroll Taxes Adjustments ({{hiRsOwner?.DISPLAY_NAME || hiRsOwner?.NAME}})</div>
      </ng-container>
      <ng-container *ngIf="reportService.hasOwnershipUnnamedGmAdjustments()">
        <div class="sub__header">Less: Annual Fair Market Replacement Salary</div>
          <div class="sub__header">Less: Payroll Taxes Adjustments</div>
      </ng-container>
      <div class="header">EBITDA</div>
    </div>

    <div class="col-lg-8 col-md-6 col-6">
      <div class="row flex-nowrap table__body custom__scroll vertical__Scroll overflow-y-hidden">
        <div class="col-lg-3 col-md-9 col-9 p-0 table-column" *ngFor="let istData of IncomeStatementTable; let i = index">
          <div class="table-column-cell">
            <span class="value" *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
              {{istData.TOTAL_ADJUSTMENTS | number}}
            </span>
            <span class="value" *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
              0
            </span>
          </div>
          <div class="table-column-cell">
            <div class="d-flex align-items-center w-100" *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
              <span class="value pr-0 flex-grow-1">
                $ {{istData.SDE | number}}
              </span>
              <ist-margin [revenue]="istData.REVENUE" [fieldValue]="istData.SDE"></ist-margin>
            </div>
            <div class="d-flex align-items-center w-100" *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
              <span class="value pr-0 flex-grow-1">
                $ 0
              </span>
              <ist-margin [revenue]="0" [fieldValue]="0"></ist-margin>
            </div>
          </div>

          <ng-container *ngIf="reportService.hasOwnershipAdjustments()">
            <div class="table-column-cell">
              <ng-container *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                <number-input [(ngModel)]="hiRsOwner.REPLACEMENT_SALARY"
                  [classes]="'input silent-input'"
                  #HI_SALARY_OWNER="ngModel"
                  name="HI_SALARY_OWNER_{{i}}"
                  [disabled]="currentReport?.isLocked"
                  [allowZero]="true"
                  [clearZero]="false"
                  *ngIf="isEditMode"
                  (blur)="updateOwnerSalaryValue('REPLACEMENT_SALARY', hiRsOwner)"
                  id="HI_SALARY_OWNER_{{i}}"></number-input>

                <div class="value" *ngIf="!isEditMode">
                  ({{currencyPipe.transform(hiRsOwner.REPLACEMENT_SALARY)}})
                </div>
              </ng-container>
              <input type="text" id="adjustments-owner-replacement-salary-data" class="input silent-input" disabled [value]="'0'"
                *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell">
              <div class="value" *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                ({{currencyPipe.transform(reportService.calculateTaxAdjustment(hiRsOwner?.REPLACEMENT_SALARY))}})
              </div>
              <div class="value" *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                (0)
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="reportService.hasOwnershipUnnamedGmAdjustments()">
            <div class="table-column-cell">
              <ng-container *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                <number-input [(ngModel)]="currentReport.LATEST.UNNAMED_SALARY"
                  [classes]="'input silent-input'"
                  #UNNAMED_SALARY="ngModel"
                  [disabled]="currentReport?.isLocked"
                  name="UNNAMED_SALARY_{{i}}"
                  [allowZero]="true"
                  [clearZero]="false"
                  *ngIf="isEditMode"
                  (blur)="updateReportVersionValue('UNNAMED_SALARY')"
                  id="UNNAMED_SALARY_{{i}}"></number-input>

                <div class="value" *ngIf="!isEditMode">
                  ({{currencyPipe.transform(currentReport.LATEST.UNNAMED_SALARY)}})
                </div>
              </ng-container>
              <input type="text" id="adjustments-unnamed--salary-data"  class="input silent-input" disabled [value]="'0'"
                *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
            </div>
            <div class="table-column-cell">
              <div class="value" *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                ({{currencyPipe.transform(reportService.calculateTaxAdjustment(currentReport.LATEST.UNNAMED_SALARY))}})
              </div>
              <div class="value" *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                (0)
              </div>
            </div>
          </ng-container>

          <div class="table-column-cell gray-border-bottom">
            <div class="d-flex align-items-center w-100" *ngIf="istData.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
              <div class="value pr-0">
                $ {{istData.EBITDA | number}}
              </div>
              <ist-margin [revenue]="istData.REVENUE" [fieldValue]="istData.EBITDA"></ist-margin>
            </div>
            <div class="d-flex align-items-center w-100" *ngIf="istData.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
              <div class="value pr-0">
                $ 0
              </div>
              <ist-margin [revenue]="0" [fieldValue]="0"></ist-margin>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
<report-footer (buttonClicked)="footerButtonClick($event)" [skipAvailable]="!currentReport?.isLocked"
  [skipBtnText]="common.isMobileDevice ? isEditMode ? 'View' : 'Edit' : isEditMode ? 'View Values' : 'Edit Summary Values'" [skipArrow]="false"
  [mobileIcon]="isEditMode ? 'eye-icon' : 'edit-icon'"
  [nextBtnEnable]="!adjustmentForm.invalid || currentReport?.isLocked" [pageId]="reportPageConst.ADJUSTMENTS">
</report-footer>
